import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SurveyForm.css';
import cx from 'classnames';
import SendSurveyButton from '../SendSurveyButton';
import SurveyError from '../SurveyError';
import ReasonsSelector from '../ReasonsSelector';
import CommentField from '../CommentField';
import ScoreSelector from '../ScoreSelector';

const SurveyForm = () => {
  const [score, setScore] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [comment, setComment] = useState('');
  const [options, setOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    // Busca as razões na API

    const apiGetUrl = process.env.REACT_APP_GET_REASONS_API_URL;


    axios.get(`${apiGetUrl}?survey_type=ECOM`)
      .then(response => {
        setReasons(response.data.records);
        setErrorMessage(null);
      })
      .catch(error => {
        setErrorMessage('Erro ao carregar os motivos. Tente novamente mais tarde.')
      });


    // Verifica se há um score na URL e o define
    const params = new URLSearchParams(window.location.search);
    const initialScore = parseInt(params.get('score'));
    if (!isNaN(initialScore)) {
      setScore(initialScore);
    }
  }, []);

  const handleScoreSelect = (selectedScore) => {
    setScore(selectedScore);
    setSelectedReason(null);
    setSelectedOption(null);
  };

  const handleReasonSelect = (reasonId) => {
    const reason = reasons.find(r => r.id === reasonId);
    setSelectedReason(reason);
    setOptions(reason ? reason.options : []);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);

  };

  return (
    <div>
      <SurveyError errorMessage={errorMessage} />
      <ScoreSelector score={score} handleScoreSelect={handleScoreSelect} />
      {score !== null && (
        <ReasonsSelector
          reasons={reasons.filter(reason => score >= reason.min_score && score <= reason.max_score)}
          selectedReason={selectedReason}
          onReasonSelect={handleReasonSelect}
        />
      )}

      {selectedReason && (
        <div className="button-container-options">
          <p>Vimos que você escolheu {selectedReason.name}, quer nos contar um pouco mais?</p>
          {options.map(option => (
            <button
              className={cx('button-options', { 'selected-option': selectedOption && selectedOption.id === option.id })}
              key={option.id}
              onClick={() => handleOptionSelect(option)}>
              {option.name}
            </button>
          ))}
        </div>
      )}

      {selectedOption && (
        <CommentField comment={comment} setComment={setComment} />
      )}

      <SendSurveyButton
        survey={{ score, reason_id: selectedReason?.id, comment, reason_option_id: selectedOption?.id }}
        id={new URLSearchParams(window.location.search).get('id')}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};
export default SurveyForm;
